export default __webpack_public_path__ + "static/media/m-token.72760828.png";